import { render, staticRenderFns } from "./TgNodata.vue?vue&type=template&id=edbad770"
import script from "./TgNodata.vue?vue&type=script&lang=js"
export * from "./TgNodata.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports